import styled from "@emotion/styled";

export const ReplacementReviewEditOrderDetailsContainer = styled.div({
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const ReplacementReviewEditOrderDetailsContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const ReplacementReviewEditOrderDetailsFirstRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	width: "100%",
	gap: "16px",
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column"
	}
}));

export const ReplacementReviewEditOrderDetailsData = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	flex: 1,
	div: {
		...theme.project.typography.subtitle.subtitle2,
		color: theme.project.colors.fontColors.main
	},
	span: {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary
	}
}));
